const jobLossTranslations = {
  en: {
    jobLoss: {
      consent_text:
        'Я подтверждаю согласие на <1>сбор и обработку персональных данных</1> а также соглашаюсь с <2>правилами страхования</2>.',
    },
  },
  kz: {
    jobLoss: {
      consent_text:
        'Я подтверждаю согласие на <1>сбор и обработку персональных данных</1> а также соглашаюсь с <2>правилами страхования</2>.',
    },
  },
  ru: {
    jobLoss: {
      consent_text:
        'Я подтверждаю согласие на <1>сбор и обработку персональных данных</1> а также соглашаюсь с <2>правилами страхования</2>.',
    },
  },
};

export default jobLossTranslations;
